module.exports = __webpack_public_path__ + "media/customizations/colton/logo-577fca9bf7679a8a6557e55df4091e5d.png";